import React from "react";
import { Colors } from "../../Constants/colors";
import { FontSize } from "../../Constants/Enums/Size.enums";

export enum BadgeType {
  primary = "primary",
  secondary = "secondary",
  success = "success",
  danger = "danger",
  warning = "warning",
}

export interface CardBadgeProps {
  badgeText: string;
  badgeType: BadgeType;
}

export const CardBadge = ({ badgeText, badgeType }: CardBadgeProps) => {
  const getBadgeColor = (badgeType: BadgeType) => {
    switch (badgeType) {
      case BadgeType.success:
        return Colors.Success;
      case BadgeType.danger:
        return Colors.Tomato;
      case BadgeType.warning:
        return Colors.TangerineOrange;
      default:
        return Colors.TangerineOrange;
    }
  };

  const badgeColor = getBadgeColor(badgeType);

  return (
    <div
      className="Header pl-2 pr-2"
      style={{
        position: "relative",
        minWidth: "100px",
        borderTopLeftRadius: "4px",
        borderBottomLeftRadius: "4px",
        borderBottomRightRadius: "4px",
        color: Colors.White,
        fontSize: FontSize.F12,
        backgroundColor: `${badgeColor}90`, // Applying opacity
        fontWeight: 400,
        paddingTop: "2px",
        paddingBottom: "2px",
      }}
    >
      {badgeText}
      <div
        className=""
        style={{
          position: "absolute",
          width: 0,
          height: 0,
          top: -8,
          right: 0,
          borderRight: "10px solid transparent",
          borderBottom: `8px solid ${badgeColor}`,
        }}
      />
    </div>
  );
};
